import axios from "axios";


const apiClient = axios.create({
  baseURL: process.env.REACT_APP_MALBOX_BACKENDURL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem("access_token")
  }
});

export default apiClient;
